import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @ts-ignore
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import Apache from '../../../assets/icons/apache.png';
import Mysql from '../../../assets/icons/mysql.png';
import Php from '../../../assets/icons/php.png';
import Laravel from '../../../assets/icons/laravel.png';
import Node from '../../../assets/icons/node.png';
import WordPress from '../../../assets/icons/wordpress.png';
import Tv from "../../../assets/icons/wifi.png";
import Youtube from "../../../assets/icons/youtube.png";
import Facebook from "../../../assets/icons/facebook.png";
import Instagram from "../../../assets/icons/instagram.png";
import Tiktok from "../../../assets/icons/tiktok.png";
import GoogleMeet from "../../../assets/icons/googlemeet.png";
import Netflix from "../../../assets/icons/netflix.png";
import Gamer from "../../../assets/icons/gamer.png";
import Streaming from "../../../assets/icons/streaming.png";
import Rural from "../Rural";
import Lte from "../../../assets/images/lte.png";
import Farm from '../../../assets/images/farm.png';


import * as RiIcons from "react-icons/ri";
import { IconWorldWww } from '@tabler/icons-react';
import * as FcIcons from "react-icons/fc";
import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FaIcons from "react-icons/fa";

import './styles.css';
import ResidencialLite from "./components/ResidencialLite";
import ResidencialPlus from "./components/ResidencialPlus";
import ResidencialMaster from "./components/ResidencialMaster";
import LinkDedicado from './components/LinkDedicado';
import ResidencialGamer from './components/ResidencialGamer';

const Planos = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  const [fullscreen] = useState(true);

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showModal6, setShowModal6] = useState(false);

  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);
  const handleCloseModal3 = () => setShowModal3(false);
  const handleCloseModal4 = () => setShowModal4(false);
  const handleCloseModal5 = () => setShowModal5(false);
  const handleCloseModal6 = () => setShowModal6(false);

  const handleOpenModal1 = () => setShowModal1(true);
  const handleOpenModal2 = () => setShowModal2(true);
  const handleOpenModal3 = () => setShowModal3(true);
  const handleOpenModal4 = () => setShowModal4(true);
  const handleOpenModal5 = () => setShowModal5(true);
  const handleOpenModal6 = () => setShowModal6(true);


  return (
    <div className="container plan">
      <div className="row  py-4">
        <h1>Residencial</h1>
        <h4>Instruções para auxiliar o Cliente na escolha do plano de internet residencial</h4>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> 10 MEGAS  </h2>
              </div>
              <div className="plano-tv">
                <Card.Header><span>Residencial Lite</span></Card.Header>
              </div>
              <Card.Body>
                <Card.Text>
                  <div className="img-icon">
                    <RiIcons.RiHomeWifiLine />
                    <span>Plano Residencial</span>
                    <p>plano básico 10 megas, conexão adequada para tarefas do dia a dia para até 3 dispositivos</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>100% Fibra Óptica</span>
                    <p>Internet de qualidade superior, confiável e sempre disponível. </p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillThunderbolt />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação e <strong>o preço podem variar conforme a cidade</strong>, clique no botão Saiba mais para informações detahadas. </p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaDownload />
                    <span>Velocidade de Download</span>
                    <p>10 MEGAS</p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaUpload />
                    <span>Velocidade de Upload</span>
                    <p>5 MEGAS </p>
                    <div className="img-icon-content">
                      <img src={Facebook} alt="icon" />
                      <img src={Instagram} alt="icon" />
                      <img src={Youtube} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <p>
                      Pagando antes ou até a data do vencimento tem R$ 10,00 de desconto.
                    </p>
                    <h6>
                      de R$ 60,00/MÊS
                    </h6>
                    <span>
                      por R$ 50,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Lembre-se que o valor do plano é R$60,00 e que pagando em dias o cliente terá desconto de R$10,00.
                    </p>
                    <p>
                      Após a data de vencimento o valor será de R$60,00 mais despesas bancarias.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal1}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Modal show={showModal1} onHide={handleCloseModal1} fullscreen={fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div className='info-title'>
                <h2><FcIcons.FcAbout /> </h2> <h4>Informações úteis sobre nosso Plano de 10 MEGAS</h4>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body scrollable={true}>
            <ResidencialLite />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal1}>Fechar</Button>
          </Modal.Footer>
        </Modal>
        {/*  */}
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> 60 MEGAS </h2>
              </div>
              <div className="plano-tv">
                <Card.Header><span>Residencial Plus</span></Card.Header>
              </div>
              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <RiIcons.RiHomeWifiLine />
                    <span>Plano Residencial</span>
                    <p>plano intermediário 60 megas, internet de alta performance para até 6 dispositivos </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>100% Fibra Óptica</span>
                    <p>Internet de qualidade superior, confiável e sempre disponível. </p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillThunderbolt />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação e <strong>o preço podem variar conforme a cidade</strong>, clique no botão Saiba mais para informações detahadas. </p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaDownload />
                    <span>Velocidade de Download</span>
                    <p>60 MEGAS</p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaUpload />
                    <span>Velocidade de Upload</span>
                    <p>30 MEGAS </p>
                    <div className="img-icon-content">
                      <img src={Tiktok} alt="icon" />
                      <img src={Netflix} alt="icon" />
                      <img src={GoogleMeet} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <p>
                      Pagando antes ou até a data do vencimento tem R$ 10,00 de desconto.
                    </p>
                    <h6>
                      de R$ 70,00/MÊS
                    </h6>
                    <span>
                      por R$ 60,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Lembre-se que o valor do plano é R$70,00 e que pagando em dias o cliente terá desconto de R$10,00.
                    </p>
                    <p>
                      Após a data de vencimento o valor será de R$70,00 mais despesas bancarias.
                    </p>
                  </div>

                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal2}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Modal show={showModal2} onHide={handleCloseModal2} fullscreen={fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title>Informações úteis sobre o Plano GigaPlus de 60 MEGAS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ResidencialPlus />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal2}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> 400 MEGAS  </h2>
              </div>
              <div className="plano-tv">
                <Card.Header><span>Residencial Master</span></Card.Header>
              </div>
              <Card.Body>
                <Card.Text>
                  <div className="img-icon">
                    <RiIcons.RiHomeWifiFill /><span>Plano Residencial</span>
                    <p>plano perfeito para residências com grande número de dispositivos conectados.</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>100% Fibra Óptica</span>
                    <p>Internet de qualidade superior, confiável e sempre disponível. </p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillThunderbolt />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação e <strong>o preço podem variar conforme a cidade</strong>, clique no botão Saiba mais para informações detahadas. </p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaDownload />
                    <span>Velocidade de Download</span>
                    <p>400 MEGAS</p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaUpload />
                    <span>Velocidade de Upload</span>
                    <p>200 MEGAS </p>
                    <div className="img-icon-content">
                      <img src={Netflix} alt="icon" />
                      <img src={Gamer} alt="icon" />
                      <img src={Streaming} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <p>
                      Pagando antes ou até a data do vencimento tem R$ 10,00 de desconto.
                    </p>
                    <h6>
                      de R$ 110,00/MÊS
                    </h6>
                    <span>
                      por R$ 100,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Lembre-se que o valor do plano é R$110,00 e que pagando em dias o cliente terá desconto de R$10,00.
                    </p>
                    <p>
                      Após a data de vencimento o valor será de R$110,00 mais despesas bancarias.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal3}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>

        <Modal show={showModal3} onHide={handleCloseModal3} fullscreen={fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title>Informações úteis sobre o Plano GigaMaster de 400 MEGAS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ResidencialMaster />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal3}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>


        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> 600 MEGAS  </h2>
              </div>
              <div className="plano-tv">
                <Card.Header><span>Residencial Master</span></Card.Header>
              </div>
              <Card.Body>
                <Card.Text>
                  <div className="img-icon">
                    <RiIcons.RiHomeWifiFill /><span>Plano Residencial</span>
                    <p>plano perfeito para residências com grande número de dispositivos conectados.</p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcApproval /><span>100% Fibra Óptica</span>
                    <p>Internet de qualidade superior, confiável e sempre disponível. </p>
                  </div>
                  <div className="img-icon">
                    <AiIcons.AiFillThunderbolt />
                    <span>Instalação rápida</span>
                    <p>o prazo de instalação e <strong>o preço podem variar conforme a cidade</strong>, clique no botão Saiba mais para informações detahadas. </p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaDownload />
                    <span>Velocidade de Download</span>
                    <p>600 MEGAS</p>
                  </div>
                  <div className="img-icon">
                    <FaIcons.FaUpload />
                    <span>Velocidade de Upload</span>
                    <p>300 MEGAS </p>
                    <div className="img-icon-content">
                      <img src={Netflix} alt="icon" />
                      <img src={Gamer} alt="icon" />
                      <img src={Streaming} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <p>
                      Pagando antes ou até a data do vencimento tem R$ 10,00 de desconto.
                    </p>
                    <h6>
                      de R$ 130,00/MÊS
                    </h6>
                    <span>
                      por R$ 120,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Lembre-se que o valor do plano é R$130,00 e que pagando em dias o cliente terá desconto de R$10,00.
                    </p>
                    <p>
                      Após a data de vencimento o valor será de R$130,00 mais despesas bancarias.
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary" onClick={handleOpenModal4}>Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>


        <Modal show={showModal4} onHide={handleCloseModal4} fullscreen={fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title>Informações úteis sobre o Plano GigaGamer de 600 MEGAS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ResidencialGamer />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={handleCloseModal4}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <hr />
        {/*        */}

        <div className="row">
          <div className="col-sm-12 col-md-6">
            <div className="content-card">
              <Card>
                <div className="img-icon-tv">
                  <img src={Tv} alt="foto" />
                  <h2> INTERNET RURAL </h2>
                </div>
                <div className="plano-tv">
                  <Card.Header><span>Rural 4G LTE</span></Card.Header>
                </div>
                <Card.Body>

                  <Card.Text>
                    <div className="img-icon">
                      <RiIcons.RiBaseStationLine /><span>Plano Rural</span>
                      <p>velocidade de até 10 MEGAS e o melhor: <strong>sem franquia de dados (download e upload ilimitados)</strong></p>
                    </div>
                    <div className="img-icon">
                      <FcIcons.FcSimCard /><span>Tecnologia 4G LTE</span>
                      <p>conexão de qualidade comprovada, tecnologia reconhecida e amplamente utilizada em celulares. </p>
                    </div>
                    <div className="img-icon">
                      <AiIcons.AiFillThunderbolt />
                      <span>Instalação rápida</span>
                      <p>o prazo de instalação pode variar até que o cliente mande a localização para análise de nossa equipe técnica. </p>
                    </div>
                    <div className="img-icon">
                      <FaIcons.FaDownload />
                      <span>Velocidade de Download</span>
                      <p>10 MEGAS</p>
                    </div>
                    <div className="img-icon">
                      <FaIcons.FaUpload />
                      <span>Velocidade de Upload</span>
                      <p>5 MEGAS </p>
                      <div className="img-icon-content">
                        <img src={GoogleMeet} alt="icon" />
                        <img src={Youtube} alt="icon" />
                        <img src={Facebook} alt="icon" />
                      </div>
                    </div>
                    <div className="price">
                      <p>
                        Pagando antes ou até a data do vencimento tem R$ 10,00 de desconto.
                      </p>
                      <h6>
                        de R$ 110,00/MÊS
                      </h6>
                      <span>
                        por R$ 100,00/MÊS
                      </span>
                      <hr />
                      <p>
                        Lembre-se que o valor do plano é R$110,00 e que pagando em dias o cliente terá desconto de R$10,00.
                      </p>
                      <p>
                        Após a data de vencimento o valor será de R$110,00 mais despesas bancarias.
                      </p>
                    </div>
                  </Card.Text>
                  <Button variant="primary" onClick={handleOpenModal5}>Saiba mais...</Button>
                </Card.Body>
              </Card>
            </div>
          </div>


          <Modal show={showModal5} onHide={handleCloseModal5} fullscreen={fullscreen} >
            <Modal.Header closeButton>
              <Modal.Title><div className="img-title"><img src={Lte} alt="foto" /> </div></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="farm-foto">
                  <h2><FcIcons.FcSimCard /> INTERNET 4G LTE RURAL  </h2>
                  <img src={Farm} alt='foto' />
                </div>
                <Card>
                  <Card.Body>
                    <Card.Text>
                      <Rural />
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={handleCloseModal5}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>



          <div className="col-sm-12 col-md-6">
            <div className="content-card">
              <Card>
                <div className="img-icon-tv">
                  <img src={Tv} alt="foto" />
                  <h2> LINK DEDICADO </h2>
                </div>
                <div className="plano-tv">
                  <Card.Header><span>Internet Corporativa</span></Card.Header>
                </div>
                <Card.Body>

                  <Card.Text>
                    <div className="img-icon">
                      <FcIcons.FcMoneyTransfer /><span>Plano Corporativo</span>
                      <p>velocidade da conexão de acordo com a necessidade do cliente, planos partir de 50 MEGAS </p>
                    </div>
                    <div className="img-icon">
                      <BiIcons.BiGitBranch /><span>Link exclusivo</span>
                      <p>internet dedicada, sem compartilhamento </p>
                    </div>
                    <div className="img-icon">
                      <AiIcons.AiFillThunderbolt />
                      <span>Suporte técnico diferenciado</span>
                      <p>Conte com um plantão de suporte técnico exclusivo e especializado, 24 horas por dia, 7 dias por semana </p>
                    </div>
                    <div className="img-icon">
                      <IconWorldWww size={18} />
                      <span>IPs Públicos fixos</span>
                      <p>Com um link dedicado, você terá 5 IPs públicos fixos exclusivamente destinados a serviços como hospedagem de servidores web, Sistemas ERPs e outras publicações diretamente na internet.</p>
                    </div>
                    <div className="img-icon">
                      <FcIcons.FcShop />
                      <span>Publique seus servidores</span>
                      <p>Com essa solução, você terá a capacidade de disponibilizar seus serviços online, garantimos a estabilidade e confiabilidade necessárias para uma presença online eficiente e de alto desempenho.</p>
                      <div className="img-icon-content">
                        <img src={Apache} alt="icon" />
                        <img src={Php} alt="icon" />
                        <img src={Mysql} alt="icon" />
                        <img src={Laravel} alt="icon" />
                        <img src={Node} alt="icon" />
                        <img src={WordPress} alt="icon" />
                      </div>
                    </div>
                    <div className="price">
                      <p>
                        Preço ???????
                      </p>
                      <h6>
                        de R$ 0000,00/MÊS
                      </h6>
                      <span>
                        por R$ 0000,00/MÊS
                      </span>
                      <hr />
                      <p>
                        Lembre-se que o valor do plano é R$0000,00 e que pagando em dias o cliente terá desconto de R$00,00.
                      </p>
                      <p>
                        Após a data de vencimento o valor será de R$0000,00 mais despesas bancarias.
                      </p>
                    </div>
                  </Card.Text>
                  <Button variant="primary" onClick={handleOpenModal6}>Saiba mais...</Button>
                </Card.Body>
              </Card>
              <div className="end"></div>
            </div>
          </div>

          <Modal show={showModal6} onHide={handleCloseModal6} fullscreen={fullscreen}>
            <Modal.Header closeButton>
              <Modal.Title>Informações úteis sobre Link Dedicado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <LinkDedicado />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={handleCloseModal6}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  )
}
export default Planos;
